import { Component, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { InactivityService } from '@services/InactivityService ';
import { AuthService } from '@services/auth/auth.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  private isMonitoring = false;

  constructor(
    private primengConfig: PrimeNGConfig,
    private router: Router,
    private inactivityService: InactivityService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.primengConfig.ripple = true;

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        const url = this.router.url;

        const rutasExcluidas = ['/login', '/2fa'];
        const estaAutenticado = this.authService.isLoggedIn();

        if (!rutasExcluidas.includes(url) && estaAutenticado && !this.isMonitoring) {
          console.log('🟢 Iniciando monitoreo de inactividad');
          this.inactivityService.startMonitoring();
          this.isMonitoring = true;
        }

        if (rutasExcluidas.includes(url) && this.isMonitoring) {
          console.log('🛑 Deteniendo monitoreo en login/2FA');
          this.inactivityService.stopMonitoring();
          this.isMonitoring = false;
        }
      });
  }
}
